import React from 'react';
import PrimaryHeading from "../../components/PrimaryHeading/PrimaryHeading";
import HeadingGradient from "../../components/HeadingGradient/HeadingGradient";
import Tile from "../../components/Tile/Tile";
import SecondaryHeading from "../../components/SecondaryHeading/SecondaryHeading";
import ThirdHeading from "../../components/ThirdHeading/ThirdHeading";
import TimeChart from "../../components/TimeChart/TimeChart";
import ChartLegend from "../../components/ChartLegend/ChartLegend";
import { timeChartLegendData } from "./DetailsPage.helpers";
import TileLegend from "../../components/TileLegend/TileLegend";
import BarChartOccasion from "../../components/BarChart/BarChart";

function SectionWhen({ timeTotalChartData, timeChartData, occasionsData }) {
    return (
        <>
            <div className="details-chart">
                <PrimaryHeading>
                    <HeadingGradient>When</HeadingGradient>
                </PrimaryHeading>
                <Tile>
                    <SecondaryHeading>
                        Time Of Day
                    </SecondaryHeading>
                    <div className="row">
                        <div className="col-50">
                            <ThirdHeading>
                                Total
                            </ThirdHeading>
                            <div className="time-chart-wrap">
                                <TimeChart linesData={timeTotalChartData}/>
                            </div>
                        </div>
                        <div className="col-50">
                            <ThirdHeading>
                                At-Home vs. AFH
                            </ThirdHeading>
                            <div className="time-chart-wrap">
                                <ChartLegend
                                    data={timeChartLegendData}
                                />
                                <TimeChart linesData={timeChartData}/>
                            </div>
                        </div>
                    </div>
                </Tile>
            </div>
            <div className="details-chart">
                <Tile>
                    <SecondaryHeading>
                        Occasion
                        {/*<TileLegend />*/}
                    </SecondaryHeading>
                    <BarChartOccasion data={occasionsData}/>
                </Tile>
            </div>
        </>
    );
}

export default SectionWhen;